export const VIDEO_MAX_SIZE = 500 // 视频大小500M限制
export const VIDEO_DURATION = 300 // 视频时长500s限制
export const IMAGE_MAX_SIZE = 10 // 图片大小10M限制
export const IMAGE_TYPE = '1' // 图片类型
export const VIDEO_TYPE = '2' // 视频类型
export const SUBMIT_MEDIA_ONLY_IMAGE = '1' // 仅提交图文
export const SUBMIT_MEDIA_ONLY_VIDEO = '3' // 仅提交视频
export const SUBMIT_MEDIA_HYBRID = '5' // 图片和视频混合类型
